import { t } from '@lingui/core/macro';
import { StepFlowStep } from 'noddi-ui-web';

export const FEEDBACK_STEP_KEYS = [
  'EASE_OF_BOOKING',
  'COMMUNICATION',
  'RESULT',
  'POLITENESS',
  'OVERALL',
  'COMMENT'
] as const;

export type FeedbackStepKey = (typeof FEEDBACK_STEP_KEYS)[number];
export type FeedbackRatingStepKey = Exclude<FeedbackStepKey, 'COMMENT'>;

// `optional` is the flow's own: it turns Continue into Skip and notes it under the question.
export const getFeedbackSteps = (): (StepFlowStep & { key: FeedbackStepKey; optional?: boolean })[] => [
  { key: 'EASE_OF_BOOKING', label: t`Ease of booking` },
  { key: 'COMMUNICATION', label: t`Communication` },
  { key: 'RESULT', label: t`Result of the service` },
  { key: 'POLITENESS', label: t`Politeness`, optional: true },
  { key: 'OVERALL', label: t`Overall experience` },
  { key: 'COMMENT', label: t`Comment`, optional: true }
];

export const getFeedbackQuestions = (): Record<FeedbackRatingStepKey, string> => ({
  EASE_OF_BOOKING: t`How easy did you find it to book the service?`,
  COMMUNICATION: t`How would you rate our communication before the appointment?`,
  RESULT: t`How satisfied are you with the result of the job?`,
  // eslint-disable-next-line noddi/no-banned-ui-terms -- consumer copy: end customers read 'technician'; 'worker' is the backoffice term
  POLITENESS: t`How polite did you find the technician to be?`,
  OVERALL: t`How likely are you to recommend us to someone else?`
});
